import { FormEvent, useState } from 'react';

import { useAuth } from '@/auth/useAuth';

export function Login() {
  const [email, setEmail] = useState('');
  const { loading, error, loginWithEmail } = useAuth();

  const handleSubmit = async (event: FormEvent) => {
    event.preventDefault();
    await loginWithEmail(email);
  };

  return (
    <div className="flex min-h-screen bg-gray-50">
      <div className="mx-auto flex w-full max-w-md flex-col justify-center px-6 py-12">
        <div className="rounded-2xl bg-white p-8 shadow-sm ring-1 ring-gray-200">
          <div className="mb-8">
            <h1 className="text-2xl font-semibold text-gray-900">Sign in</h1>
            <p className="mt-2 text-sm text-gray-600">
              Enter your work email to continue with your organization&apos;s SSO
            </p>
          </div>

          {error ? (
            <div className="mb-6 rounded-lg border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-700">
              {error}
            </div>
          ) : null}

          <form className="space-y-6" onSubmit={handleSubmit}>
            <div>
              <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                Email address
              </label>
              <div className="mt-2">
                <input
                  id="email"
                  name="email"
                  type="email"
                  autoComplete="email"
                  required
                  value={email}
                  onChange={(event) => setEmail(event.target.value)}
                  disabled={loading}
                  placeholder="you@company.com"
                  className="block w-full rounded-lg border border-gray-300 px-3 py-2 text-gray-900 shadow-sm placeholder:text-gray-400 focus:border-gray-900 focus:outline-none focus:ring-2 focus:ring-gray-900/10 disabled:cursor-not-allowed disabled:bg-gray-100"
                />
              </div>
            </div>

            <button
              type="submit"
              disabled={loading || !email}
              className="flex w-full items-center justify-center rounded-lg bg-gray-900 px-3 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-gray-800 disabled:cursor-not-allowed disabled:bg-gray-400"
            >
              {loading ? 'Signing in...' : 'Continue'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
